import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PostSkeletonLoader from './PostSkeletonLoader';
import toast from 'react-hot-toast';
import { getPost } from '../../../helper/api.helper';
import BodyContent from './BodyContent';
import AuthorDetails from './AuthorDetails';
import Banner from './Banner';
import ActionButton from './ActionButton';
import { getOrgCode } from '../../../helper/utils.helper';

const Post = () => {
  const { postSlug } = useParams();
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [post, setPost] = useState({});

  useEffect(() => {
    const orgCode = getOrgCode();
    if (orgCode && postSlug) {
      setLoading(true);
      getPost(orgCode, postSlug)
        .then((res) => res.json())
        .then((res) => {
          if (res.status === 'success') {
            setLoading(false);
            setPost(res.data);
          } else {
            setLoading(false);
            toast.error(res.message);
            navigate('/');
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err.message);
        });
    }
  }, [postSlug]);

  return (
    <div className="posts-wrapper">
      {isLoading ? (
        <PostSkeletonLoader />
      ) : (
        <>
          <h1 className="title">{post?.title}</h1>
          <AuthorDetails authorName={post?.author} />
          <Banner actionLink={post?.action_link} bannerUrl={post?.banner} postTitle={post?.title} />
          <BodyContent body={post?.body} />
          <ActionButton link={post?.action_link} />
        </>
      )}
      <style jsx>
        {`
          .posts-wrapper {
            padding: 20px;
            min-height: 90vh;
            max-width: 1150px;
            margin: auto;
          }
        `}
      </style>
    </div>
  );
};

export default Post;
